<div class="min-h-screen bg-gray-900">
  <app-notification></app-notification>
  <div class="py-10">
    <header>
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between gap-4">
          <h1 class="text-3xl font-bold leading-tight tracking-tight text-white flex-shrink-0">Menu</h1>
        </div>
      </div>
    </header>
    <main>
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-8">
        <div *ngIf="!currentDomain" class="text-center py-12">
          <p class="text-gray-400">Selecteer een website om het menu te beheren</p>
        </div>

        <div *ngIf="currentDomain" class="space-y-6">
          <!-- Language Selector -->
          <div class="bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm p-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-4">
                <span class="text-sm font-medium text-gray-300">Taal:</span>
                <div class="flex space-x-2">
                  <button 
                    *ngFor="let lang of availableLanguages"
                    (click)="setCurrentLanguage(lang.code)"
                    [class]="currentLocale === lang.code ? 
                      'bg-indigo-600 text-white' : 
                      'bg-gray-700 text-gray-300 hover:bg-gray-600'"
                    class="px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-200">
                    {{ lang.code.toUpperCase() }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Menu Editor -->
          <app-menu-editor 
            [domain]="currentDomain"
            [currentLocale]="currentLocale"
            (menuChanged)="onMenuChanged()"
          ></app-menu-editor>
        </div>
      </div>
    </main>
  </div>
</div>
